<section class="section" id="how-it-works">
	<div class="inner">
		<p class="section-label">How It Works</p>
		<h2 class="section-title">Precision Skincare</h2>
		<div class="steps">
			<div class="step">
				<div class="step-number">I</div>
				<h3>Capture</h3>
				<p>Our computer-vision model reads your selfie and scores 11 skin characteristics, from acne to under-eye wrinkles.</p>
			</div>
			<div class="step">
				<div class="step-number">II</div>
				<h3>Analyze</h3>
				<p>We match your profile against thousands of products from Sephora, Ulta and Amazon, using their ingredients and real customer reviews.</p>
			</div>
			<div class="step">
				<div class="step-number">III</div>
				<h3>Recommend</h3>
				<p>Get a morning and evening routine ordered around what your skin actually needs.</p>
			</div>
		</div>
	</div>
</section>

<style>
	/* Same scaffolding in all four landing sections: one band of --section-gap
	   top and bottom, one --content-max container, the shared label/title. */
	.section {
		padding: var(--section-gap) var(--page-pad-x);
		background: var(--surface);
	}

	.inner {
		max-width: var(--content-max);
		margin: 0 auto;
	}

	/* The shared .section-title parks --section-gap below itself, which
	   double-counts against this section's own --section-gap padding. Type,
	   colour and alignment stay from the primitive; only the trailing space
	   is re-parked, identically in all four landing sections. */
	.section-title {
		margin-bottom: var(--space-12);
	}

	/* Hairline grid: the 1px gap shows the container through. auto-fit drops
	   to one column on narrow screens with no media query. */
	.steps {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
		gap: var(--space-px);
		background: var(--border);
	}

	.step {
		background: var(--surface);
		padding: var(--space-14) var(--space-8);
		text-align: center;
	}

	.step-number {
		font-family: var(--font-display);
		font-size: var(--text-3xl);
		font-weight: var(--weight-regular);
		line-height: var(--leading-tight);
		color: var(--rose);
		margin-bottom: var(--space-6);
	}

	.step h3 {
		font-family: var(--font-body);
		font-size: var(--text-sm);
		font-weight: var(--weight-medium);
		letter-spacing: var(--track-label);
		text-transform: uppercase;
		color: var(--cream);
		margin: 0 0 var(--space-4);
	}

	.step p {
		max-width: 34ch;
		margin: 0 auto;
		font-size: var(--text-sm);
		font-weight: var(--weight-light);
		line-height: var(--leading-relaxed);
		color: var(--text-muted);
	}
</style>
